function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRightLight = function SvgArrowRightLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.933,
    height: 10.986
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m5.933 5.491-4.805 5.495L0 10l3.939-4.5L.006.991 1.138 0Z",
    style: {
      fill: "#a4a4a4",
      fillRule: "evenodd"
    }
  }));
};

export { SvgArrowRightLight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1LjkzMyIgaGVpZ2h0PSIxMC45ODYiIHZpZXdCb3g9IjAgMCA1LjkzMyAxMC45ODYiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNhNGE0YTQ7CiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBpZD0iYXJyb3ctcmlnaHQtbGlnaHQiIGNsYXNzPSJjbHMtMSIgZD0iTTUuOTMzLDUuNDkxLDEuMTI4LDEwLjk4NiwwLDEwLDMuOTM5LDUuNS4wMDYuOTkxLDEuMTM4LDBaIi8+Cjwvc3ZnPgo=";